import axios from "axios";
import { BASE_URL } from "../config";
import { SET_SITE_DATA, SET_MEIN_TRAINING_MODAL,SET_PROGRAM_LIST, SET_CART_DATA,SET_HEART_DATA, SET_USER_DATA, SET_LOADING,SET_COUPON_DATA,SET_HEADER_COLOR,SET_CART_DETAILS,SET_LANGUAGE_LOAD,SET_HEADER_TEXT_COLOR,SET_RECIPE_PLAN} from "./Action";
import { toast } from "react-toastify";

export const setloading = (data) => ({
  type: SET_LOADING,
  payload: data,
});
export const setLanguageLoad = (data) => ({
  type: SET_LANGUAGE_LOAD,
  payload: data,
});

export const setSiteData = (data) => ({
  type: SET_SITE_DATA,
  payload: data,
});

export const cartData = (data) => ({
  type: SET_CART_DATA,
  payload: data,
});
export const heartData = (data) => ({
  type: SET_HEART_DATA,
  payload: data,
});
export const cartDetails = (data) => ({
  type: SET_CART_DETAILS,
  payload: data,
});
export const couponData = (data) => ({
  type: SET_COUPON_DATA,
  payload: data,
});
export const setUserData = (data) => ({
  type: SET_USER_DATA,
  payload: data,
});
export const setHeaderColor = (data) => ({
  type: SET_HEADER_COLOR,
  payload: data,
});

export const setHeaderTextColor = (data) => ({
  type: SET_HEADER_TEXT_COLOR,
  payload: data,
});
export const setMeinTrainingModal = (data) => ({
  type: SET_MEIN_TRAINING_MODAL,
  payload: data,
});
export const setRecipePlan = (data) => ({
  type: SET_RECIPE_PLAN,
  payload: data,
});
export const setSection2 = (payload) => ({
  type: "SET_SECTION2",
  payload,
});

export const setProgramList = (data) => ({
  type: SET_PROGRAM_LIST,
  payload: data,
});

export const fetchSiteSettings = () => async (dispatch) => {
  try {
    await axios.get(`${BASE_URL}/site-info`)
      .then(res => {
        if (res.data.responseCode === 1) {
          dispatch(setSiteData(res.data.responseData))
        }
      })
  } catch (error) {
    console.log(error);
  }
}
export const fetchCartItems = () => async (dispatch) => {
  try {
    let id = '';
    let cid = ''
    let user = JSON.parse(localStorage.getItem('log_in_data'));
    let cookie_id = localStorage.getItem('cookie_id');
    if (user) {
      id = user.id
    } else {
      if (cookie_id) {
        cid = cookie_id
      } else {
        cid = Math.ceil(Math.random() * 9999999);
        localStorage.setItem('cookie_id', cid);
      }
    }
    await axios.post(`${BASE_URL}/cart-items`, { user_id: id, cookie_id: cid })
      .then(res => {
        if (res.data.responseCode === 1) {
          dispatch(cartData(res.data.responseData.carts));
          let details={
            coupon_discount:res.data.responseData.coupon_discount,
            grand_total:res.data.responseData.grand_total,
            shipping_charge:res.data.responseData.shipping_charge,
            sub_total:res.data.responseData.sub_total,
            related_product:res.data.responseData.related_product,
            only_ebooks:res.data.responseData.only_ebooks,
            is_new:res.data.responseData.is_new,
          }
          dispatch(cartDetails(details));
          dispatch(couponData(res.data.responseData.coupon));
        }
      })
  } catch (error) {
    console.log(error);
  }
}
export const fetchHeartItems = () => async (dispatch) => {
  try {
    let id = '';
    let cid = ''
    let user = JSON.parse(localStorage.getItem('log_in_data'));
    let cookie_id = localStorage.getItem('cookie_id');
    if (user) {
      id = user.id
    } else {
      if (cookie_id) {
        cid = cookie_id
      } else {
        cid = Math.ceil(Math.random() * 9999999);
        localStorage.setItem('cookie_id', cid);
      }
    }
      await axios.post(`${BASE_URL}/user/get-wishlist`, { user_id: id, cookie_id: cid })
        .then(res => {
          if (res.data.responseCode === 1) {
            dispatch(heartData(res.data.responseData));
           
          }
        })
   
  } catch (error) {
    console.log(error);
  }
}
const CustomToast = ({ closeToast,msg }) => (
  <div>
    <p>{msg}</p>
    <button
      className="btn btn-primary btn-sm mt-1" style={{background:"#f8dce8",border:"#f8dce8",color:"#212121",fontSize:"12px"}}
      onClick={() => {
        document.getElementById("loginID")?.click();
        closeToast?.();
      }}
    >
      JETZT ANMELDEN
    </button>
  </div>
);
export const logout=(navigate,msg,custom)=>async(dispatch)=>{
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("log_in_data");
    dispatch(setUserData({}));
    toast.dismiss();
    // toast.warning(msg);
  toast.warning(<CustomToast msg={msg}/>);
   navigate("/");
  } catch (error) {
    console.log(error);
  }
    }






